import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useConversationsList } from "@noa/api-client";
import { Text } from "~/components/ui";
import { ConversationHistoryCompactItem } from "./conversation-history-compact-item";

interface ConversationHistoryCompactListProps {
  onSelect?: () => void;
}

export const ConversationHistoryCompactList: FunctionComponent<ConversationHistoryCompactListProps> = ({
  onSelect,
}) => {
  const { t } = useTranslation();
  const { conversations } = useConversationsList({ limit: 10 });

  if (conversations.length === 0) return null;

  return (
    <div className="flex flex-col gap-1 pt-1">
      <Text tone="muted" className="px-3 text-xs">
        {t("conversation:recents")}
      </Text>
      <div className="flex flex-col">
        {conversations.map((c) => (
          <ConversationHistoryCompactItem key={c.session_id} conversationSummary={c} onSelect={onSelect} />
        ))}
      </div>
    </div>
  );
};
